import React, {useEffect, useState, useRef} from "react";
import api from "../../api";

const CDN_HOST = "oogst-assets.s3.eu-west-1.amazonaws.com";
const DEFAULT_CROP_IMAGE = "https://oogst.app/static/img/default-crop-image.png";

function isCdnUrl(url) {
    if (!url) return false;
    return url.includes(CDN_HOST);
}

export default function CdnImage({src, width, height, style = null, alt = ""}) {

    const [cdnSource, setCdnSource] = useState(src);
    const resizeAttempted = useRef(false);

    const cssStyle = style ? style : {
            borderRadius: '10px',
            maxWidth: '100%',
            width: width + 'px',
            height: height + 'px',
            objectFit: 'cover',
            objectPosition: 'center'
        };

    useEffect(() => {
        if(!src) {
            return
        }

        resizeAttempted.current = false;

        if(width && height && isCdnUrl(src)) {
            const ext = src.split('.').pop();
            let path = src.replace('.'+ext, '');
            const newSrc = `${path}__${width}x${height}.${ext}`
            setCdnSource(newSrc)
        } else {
            setCdnSource(src)
        }
    }, [src, width, height]);

    if(!src || !cdnSource) {
        return null
    }

    const handleError = () => {
        if (!resizeAttempted.current && width && height && isCdnUrl(src)) {
            resizeAttempted.current = true;
            // Show the original unresized image immediately while we resize
            setCdnSource(src);
            // Trigger resize in the background
            api.cdnResize(src, width, height).then((url) => {
                if (url && url !== DEFAULT_CROP_IMAGE) {
                    // Add cache-buster so browser doesn't serve the cached 403
                    setCdnSource(url + "?t=" + Date.now());
                }
            }).catch(() => {
                // Keep showing the original unresized image
            });
        } else {
            setCdnSource(DEFAULT_CROP_IMAGE);
        }
    };

    return (
        <img alt={alt} style={cssStyle} src={cdnSource} onError={handleError} />
    )
}
